module.exports = __webpack_public_path__ + "static/media/OGG-web-privacy.76008637.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-web-privacy.jpg
// module id = 637
// module chunks = 0